module.exports = {"pt-BR":{"admin":{"contracts":{"statusField":{"label":"Status"}}}}}